import { AppBar, Toolbar, Button, Typography, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from 'src/components/iconify';
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { pxToRem } from 'src/theme/typography';
import { useState } from 'react';
import { useJobCreationContext } from '../../hooks/use-job-creation-context';
import { ConfirmBackDialog } from '../../components/confirm-back-dialog';

export default function JobCreationHeader() {
  // hooks
  const {
    isSavingJob,
    currentState,
    JOB_CREATION_STATES,
    jobTitle,
    saveJobDetails,
  } = useJobCreationContext();
  const offsetTop = useOffSetTop();

  // states
  const [isBackClicked, setIsBackClicked] = useState(false);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          top: 0,
        }}
        // sx={{
        //   top: scrollDirection === 'down' ? '-5rem' : 0,
        //   transition: theme =>
        //     theme.transitions.create(['all'], {
        //       easing: theme.transitions.easing.easeInOut,
        //       duration: theme.transitions.duration.shorter,
        //     }),
        // }}
      >
        <Toolbar
          disableGutters
          sx={{
            '@media (min-width:600px)': {
              minHeight: 'auto',
            },
          }}
        >
          <Stack
            direction="row"
            width="100%"
            height="100%"
            alignItems="center"
            sx={{
              paddingTop: '29px',
              paddingBottom: '29px',
              paddingLeft: '40px',
              paddingRight: '20px',
              minHeight: 'auto',
              background: theme => theme.palette.background.primaryGrey1,
              transition: theme =>
                theme.transitions.create(['padding-top', 'padding-bottom'], {
                  easing: theme.transitions.easing.easeInOut,
                  duration: theme.transitions.duration.shorter,
                }),
              ...(offsetTop && {
                paddingTop: '10px',
                paddingBottom: '10px',
                borderBottom: theme =>
                  `1px solid ${theme.palette.border.primaryBlack3}`,
              }),
              '@media (min-width:600px)': {
                minHeight: 'auto',
              },
            }}
          >
            <Button
              onClick={() => setIsBackClicked(true)}
              sx={{
                border: theme =>
                  `1px solid ${theme.palette.border.primaryBlack3}`,
                background: theme => theme.palette.background.primaryWhite1,
                borderRadius: '4px',
                padding: '8px 10px 8px 8px',
                display: 'flex',
                justifyContent: 'start',
                height: '35px',
                width: '100px',
                minWidth: 'auto',
                mr: '160px',
              }}
              startIcon={<Iconify icon="tabler:arrow-left" />}
            >
              <Typography variant="input" fontWeight={500}>
                Back
              </Typography>
            </Button>
            <Stack spacing={offsetTop ? '8px' : '12px'}>
              <Typography
                variant="h1"
                fontWeight={600}
                sx={{
                  flexGrow: 1,
                  fontSize: pxToRem(32),
                  transition: theme =>
                    theme.transitions.create(['font-size'], {
                      easing: theme.transitions.easing.easeInOut,
                      duration: theme.transitions.duration.standard,
                    }),
                  ...(offsetTop && {
                    fontSize: pxToRem(20),
                  }),
                }}
              >
                {JOB_CREATION_STATES[currentState].label}
              </Typography>
              {(JOB_CREATION_STATES[currentState].value ===
                JOB_CREATION_STATES.AUTOPILOT_WORKFLOW.value ||
                JOB_CREATION_STATES[currentState].value ===
                  JOB_CREATION_STATES.LAUNCH.value) && (
                <Typography
                  sx={{
                    transition: theme =>
                      theme.transitions.create(['font-size'], {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.standard,
                      }),
                    fontSize: pxToRem(16),
                    ...(offsetTop && {
                      fontSize: pxToRem(12),
                    }),
                  }}
                  color={theme => theme.palette.content.primaryBlack3}
                  fontWeight={500}
                >
                  {jobTitle}
                </Typography>
              )}
            </Stack>
            <Stack flexGrow={1} />
            {JOB_CREATION_STATES[currentState].value !==
              JOB_CREATION_STATES.LAUNCH.value && (
              <LoadingButton
                loading={isSavingJob}
                loadingPosition="start"
                onClick={() => saveJobDetails()}
                sx={{
                  minWidth: 'auto',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '35px',
                  width: '100px',
                  border: theme =>
                    `1px solid ${theme.palette.border.primaryBlack3}`,
                  background: theme => theme.palette.background.primaryWhite1,
                  borderRadius: '4px',
                }}
              >
                <Typography variant="input" fontWeight={500}>
                  Save
                </Typography>
              </LoadingButton>
            )}
          </Stack>
        </Toolbar>
      </AppBar>
      <ConfirmBackDialog
        open={isBackClicked}
        handleClose={() => setIsBackClicked(false)}
      />
    </>
  );
}

JobCreationHeader.propTypes = {};
